import type { ComputedRef } from 'vue'
import {
  usarCatalogoQuery,
  usarContextoCatalogo,
  type EstadoCatalogoQuery,
} from '@next/compartilhados/catalogos'

import {
  DESCRITOR_CATALOGO_EMPREGADOR,
  type OpcaoEmpregador,
} from '../catalogo-empregador.tipos'
import { usarOperacoesCatalogoEmpregador } from './catalogo-empregador.injecao'

export const usarCatalogoEmpregador = (
  habilitado?: ComputedRef<boolean>,
): EstadoCatalogoQuery<OpcaoEmpregador> => {
  const operacoes = usarOperacoesCatalogoEmpregador()
  return usarCatalogoQuery({
    catalogo: DESCRITOR_CATALOGO_EMPREGADOR,
    contexto: usarContextoCatalogo(),
    consultar: operacoes.listarOpcoes,
    ...(habilitado ? { habilitado } : {}),
  })
}
